// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y4mvS","colBig":"styles_colBig__3JnJh","colSmall":"styles_colSmall__1ghMf","shopifyNameWrapper":"styles_shopifyNameWrapper__2Npgr"};